export var ThemeVersion;
(function (ThemeVersion) {
    ThemeVersion[ThemeVersion["DefaultTheme"] = 0] = "DefaultTheme";
    ThemeVersion[ThemeVersion["Polaris"] = 1] = "Polaris";
    ThemeVersion[ThemeVersion["Test"] = 2] = "Test";
    ThemeVersion[ThemeVersion["WebPolaris"] = 3] = "WebPolaris";
})(ThemeVersion || (ThemeVersion = {}));
//# sourceMappingURL=ThemeVersion.js.map